import { initializeApp } from "firebase/app";
import {
  getAuth,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBjXsJKw3fTIysjrpKDeqSzuJNGuHexilA",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "moto-af0cb.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "moto-af0cb",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "moto-af0cb.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1083783072515",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1083783072515:web:3ceb466b3f25ca4fc93736",
};


const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export { app };
